import styled from "styled-components"
import Icon from "../../Icon/icon"

const Article = styled.article`
  border-bottom: 1px solid ${(props) => props.theme.a_color_gradients.a_light};
`

const Type = styled.div`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const ColoredIcon = styled(Icon)`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`

export { Article, Type, ColoredIcon }
